export const ALL_CATEGORIES = 'All Categories'
export const ERROR_FETCHING_CATALOG =
  'An error occurred while fetching catalog, please try again later.'
export const FETCH_CATALOG_FAILURE = 'FETCH_CATALOG_FAILURE'
export const FETCH_CATALOG_REQUEST = 'FETCH_CATALOG_REQUEST'
export const FETCH_CATALOG_SUCCESS = 'FETCH_CATALOG_SUCCESS'
